module.exports = __webpack_public_path__ + "static/assets/2e4f01467d2e307fe2bfca65747c0331.svg";